import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["features", "formatDate"];
import React from 'react';
import { useIntl } from 'react-intl-next';
import { useSearchConfigContext } from '../../../common/search-config-provider';
import { useSearchSessionId } from '../../../common/search-session-provider';
import { useJiraSearchClientContext } from '../../../jira/clients';
import { JiraFeaturesProvider } from '../../../jira/features';
import { messages } from '../../../messages';
import { LegacyContextConverter } from '../../legacy-context-converter';
import { SearchDialogProduct } from '../../product-router';
import { EMPTY_SEARCH_ITEMS } from '../../product-router/product';
import { JiraAdvancedSearchProvider } from './jira-advanced-search-provider';
import { JiraAsyncWrapper } from './jira-async-wrapper';
import { JiraUserUpdater } from './jira-user-updater';
import { defaultPermissionsSupplier } from './permission-supplier';
export var JiraTab = function JiraTab(_ref) {
  var features = _ref.features,
    formatDate = _ref.formatDate,
    rest = _objectWithoutProperties(_ref, _excluded);
  var intl = useIntl();
  var _useSearchConfigConte = useSearchConfigContext(),
    jiraSites = _useSearchConfigConte.jiraSites;
  var _useJiraSearchClientC = useJiraSearchClientContext(),
    sites = _useJiraSearchClientC.sites,
    searchClient = _useJiraSearchClientC.searchClient;
  var searchSessionId = useSearchSessionId();
  var defaultRecentItemSupplier = function defaultRecentItemSupplier() {
    var context = {
      sessionId: searchSessionId,
      referrerId: null
    };
    return Promise.all([searchClient.getRecentIssues(context, sites).promise(), searchClient.getRecentBoardsProjectsFilters(context, sites).promise()]).then(function (results) {
      return {
        size: results.reduce(function (sum, _ref2) {
          var items = _ref2.items;
          return sum + items.length;
        }, 0),
        sections: []
      };
    });
  };

  // Post query supplier not implemented in Jira until it starts using the generic dialog components
  var defaultPostQueryItemSupplier = function defaultPostQueryItemSupplier() {
    return Promise.resolve(EMPTY_SEARCH_ITEMS);
  };
  var suppliers = {
    preQueryItemSupplier: rest.preQueryItemSupplier || defaultRecentItemSupplier,
    postQueryItemSupplier: rest.postQueryItemSupplier || defaultPostQueryItemSupplier
  };
  return /*#__PURE__*/React.createElement(LegacyContextConverter, null, /*#__PURE__*/React.createElement(JiraUserUpdater, null, /*#__PURE__*/React.createElement(JiraFeaturesProvider, {
    features: features
  }, /*#__PURE__*/React.createElement(JiraAdvancedSearchProvider, null, function (generateAdvancedSearchUrl) {
    return /*#__PURE__*/React.createElement(SearchDialogProduct, _extends({}, rest, {
      permissionSupplier: jiraSites.length > 0 ? defaultPermissionsSupplier : rest.permissionSupplier,
      PLS_DONT_USE_skipDefaultStateManagement: true,
      id: "jira",
      title: intl.formatMessage(messages.jira_tab_label)
      // A note: These sections are not actually interpreted by the Jira tab, but are put here for future use
      ,
      sections: [{
        id: 'jira.issue',
        title: intl.formatMessage(messages.jira_issues_section_heading)
      }, {
        id: 'jira.board,project,filter',
        title: intl.formatMessage(messages.jira_boards_projects_filters_section_heading)
      }]
    }, suppliers, {
      generateAdvancedSearchUrl: generateAdvancedSearchUrl,
      expandedStateInputPlaceholder: intl.formatMessage(messages.jira_search_placeholder)
    }), /*#__PURE__*/React.createElement(JiraAsyncWrapper, _extends({}, rest, {
      debounceTime: 250,
      formatDate: formatDate
    })));
  }))));
};